<template>
  <div class='param'>
    <p>
      <strong class='name'>{{ name }}</strong> <a-tag>{{ requiredText }}</a-tag>
    </p>
    <p>
      <span class='param-type'>{{ type }}</span>
    </p>
    <p v-if='defaultvalue'>
      Default: {{ defaultvalue }}
    </p>
    <p>
      {{ description }}
    </p>

  </div>
</template>

<script>

export default {
  name: 'Param',
  props: {
    name: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: true,
      default: '',
    },

    description: {
      type: String,
      required: false,
      default: '',
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },

    defaultvalue: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {

    };
  },
  computed: {
    requiredText() {
      if (this.required) {
        return 'required';
      }
      return 'optional';
    },
  },
  mounted() {

  },
};
</script>
<style scoped lang="less">
.param{
  margin-bottom: 2em;
}
p {
  margin-bottom: 0.2em;
}
.param-type {
  color: #1DA57A;
}
.name {
  font-size: 1.2em;
  margin-right: 1em;
}
</style>
